import React from "react";
import s from "./index.module.scss";
import tinycolor from "tinycolor2";

// TODO: Aria labels and accessibility.

const PrivacyRating = props => {
  const { min = 1, max = 10 } = props;
  const rating = Number(props.rating);

  const length = max + 1 - min;

  let arrForMap = [];

  for (let i = 0; i < length; i++) {
    arrForMap.push(i);
  }

  const blocks = arrForMap.map((n, index) => {
    const i = min + index;
    const isRate = rating === i;

    const innerBlockClasses = [
      s["block-inner"],
      isRate ? s["rating"] : ""
    ].join(" ");

    const bgDarkness = 255 - (255 / length) * index;
    const backgroundColor = isRate
      ? "green"
      : tinycolor(`rgb(${bgDarkness}, ${bgDarkness}, ${bgDarkness}`);
    const color = isRate
      ? "white"
      : tinycolor.mostReadable(backgroundColor, ["#fff", "#000"]);

    const blockStyle = {
      backgroundColor,
      color
    };

    return (
      <div className={s.block} key={i} style={blockStyle}>
        <span className={innerBlockClasses}>{i}</span>
      </div>
    );
  });

  return <div className={s.blocks}>{blocks}</div>;
};

export default PrivacyRating;
